import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  List,
  ListItem,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import CSAMemberTable from "./CSAMemberTable";
import CSAEnrollmentTable from "./CSAEnrollmentTable";
import AddMeterDialog from "./AddMeterDialog";
import {
  fetchProductOffers,
  findMeter,
  submitEnrollment,
  listCSAMembers,
  listPendingCSAEnrollments,
  fetchCurrentOffer,
  updateCSA,
} from "../../actions/csa";

const CSAView = ({ selected_csa, doFetchProductOffers, doFindMeter, doSubmitEnrollment, doListPendingCSAEnrollments, doListCSAMembers, doGetCurrentProduct, doUpdateCSA }) => {
  const parentCSA = selected_csa.csa;
  const userInfo = selected_csa.csa_user;
  const enrollments = selected_csa.csa_pending_enrollments;
  const recentEnrollmentId = selected_csa.new_enrollment_id;
  const [openAddMeterDialog, setOpenAddMeterDialog] = useState(false);
  const [creditApproved, setCreditApproved] = useState(selected_csa.csa?.credit_approved_meters ?? false)

  const submitMemberEnrollment = async (props) => {
    doSubmitEnrollment({ ...props, userInfo, csaInfo: parentCSA });
  }

  useEffect(() => {
    if (parentCSA?.id && userInfo?.email && parentCSA?.csa_type) {
      doListPendingCSAEnrollments({ csa_id: parentCSA.id, email: userInfo.email, csa_type: parentCSA.csa_type });
    }
  }, [parentCSA?.id, userInfo?.email, parentCSA?.csa_type, recentEnrollmentId]);

  useEffect(() => {
    setCreditApproved(parentCSA?.credit_approved_meters ?? false)
  }, [parentCSA])

  const handleCreditApprovedClick = (event) => {
    setCreditApproved(event.target.checked)
    doUpdateCSA({csa_id: parentCSA.id, credit_approved_meters: event.target.checked ? "enable" : "disable"})
  }

  return <>
    <div>
      <h5>Owner CSA</h5>
      <Grid container spacing={2}>
        <Grid item lg={4}>
          <List style={{ display: "flex", flexDirection: "column" }}>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Name:</label>
              {`${userInfo?.first_name} ${userInfo?.last_name}`}
            </ListItem>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Member ID:</label>
              <a href={`/members/${parentCSA?.member_id}/details`}>{parentCSA?.member_id}</a>
            </ListItem>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Company Name:</label>
              {parentCSA?.company_name}
            </ListItem>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Profile Name:</label>
              {parentCSA?.profile_name}
            </ListItem>
          </List>
        </Grid>
        <Grid item lg={4}>
          <List style={{ display: "flex", flexDirection: "column" }}>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Email:</label>
              {userInfo?.email}
            </ListItem>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Phone:</label>
              {userInfo?.phone}
            </ListItem>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Credit Approved:</label>
              <FormControlLabel
                labelPlacement="left"
                control={
                  <Checkbox
                    style={{padding: '0px'}}
                    checked={creditApproved}
                    onChange={handleCreditApprovedClick}
                    disabled={true}
                    color="primary"
                  />
                }
              />
            </ListItem>
            <ListItem>
              <label style={{ paddingRight: "1em" }}>Disable Meter Notifications:</label>
              <FormControlLabel
                labelPlacement="left"
                control={
                  <Checkbox
                    style={{padding: '0px'}}
                    checked={parentCSA?.disable_meter_notifications ?? false}
                    disabled={true}
                    color="primary"
                  />
                }
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>

    </div >
    <div>
      <Button style={{ float: "right" }} onClick={() => setOpenAddMeterDialog(true)} color="primary" variant="contained">Add Member</Button>
      {openAddMeterDialog && <AddMeterDialog
        open={openAddMeterDialog}
        closeDialog={() => setOpenAddMeterDialog(false)}
        parentCSA={parentCSA}
        doFetchProductOffers={doFetchProductOffers}
        doGetCurrentProduct={doGetCurrentProduct}
        userInfo={userInfo}
        doFindMeter={doFindMeter}
        submitMemberEnrollment={submitMemberEnrollment}
      />}
      <h5>CSA Members</h5>
      <CSAMemberTable
        selectedCsa={selected_csa}
        doListCSAMembers={doListCSAMembers}
        csaMembers={selected_csa.csa_members}
        recentEnrollmentId={recentEnrollmentId}
      />
      {enrollments && enrollments.length > 0 && (
        <>
          <h5>Pending Enrollments</h5>
          <CSAEnrollmentTable
            enrollments={enrollments}
          />
        </>
      )}
    </div>
  </>
};

const mapStateToProps = (state) => ({
  member: state.selectedMember,
  selected_csa: state.csa.selected_csa,
});

const mapDispatchToProps = (dispatch) => ({
  doListPendingCSAEnrollments: (params) => {
    return dispatch(listPendingCSAEnrollments(params));
  },
  doFetchProductOffers: (params) => {
    return dispatch(fetchProductOffers(params));
  },
  doFindMeter: (params) => {
    return dispatch(findMeter(params));
  },
  doSubmitEnrollment: (params) => {
    dispatch(submitEnrollment(params));
  },
  doListCSAMembers: (params) => {
    dispatch(listCSAMembers(params));
  },
  doGetCurrentProduct: (params) => {
    return dispatch(fetchCurrentOffer(params))
  },
  doUpdateCSA: (params) => {
    return dispatch(updateCSA(params))
  },
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CSAView);
